import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import CameraScan from '../pages/CameraScan';

import { StorageKeys } from '../utils/storage';

const URLParamHandler = ({ children }: { children: React.ReactNode }) => {
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const licenseUsageId = params.get('licenseUsageId') || params.get('license_usage_id');
    const licenseKey = params.get('licenseKey') || params.get('license_key');
    const returnUrl = params.get('returnUrl') || params.get('redirectUrl') || params.get('callbackUrl');

    if (licenseUsageId) localStorage.setItem(StorageKeys.LICENSE_USAGE_ID, licenseUsageId);
    if (licenseKey) localStorage.setItem('licenseKey', licenseKey);
    if (returnUrl) localStorage.setItem('returnUrl', returnUrl);
  }, []);


  return <>{children}</>;
};

const App = () => {
  return (
    <Router>
      <URLParamHandler>
        <Routes>
          <Route path="/camera-scan" element={<CameraScan />} />
          <Route path="/" element={<Navigate to="/camera-scan" replace />} />
          <Route path="*" element={<Navigate to="/camera-scan" replace />} />
        </Routes>
      </URLParamHandler>
    </Router>
  );
};



export default App;
